import api from '../../../service/api'

const GetListRevenueCode = async(pageSize,page, searchValue, orderingField, orderType) =>{
	let path = 'super-admin/revenue/?page_size='+pageSize+'&page='+page;
    if (searchValue)
        path += '&search='+ searchValue;
    if(orderingField){
        let fieldOrder = '';
        if (orderType) fieldOrder+= orderType;
        fieldOrder += orderingField;
        path += '&column='+fieldOrder;   
    } else {
        path += '&column=name';
    }
	return api.get(path);
}

const AddRevenueCode = async(data) =>{
	let path = 'super-admin/revenue/'
	return api.post(path,data);
}
const GetRevenueCode= async(id) =>{
	let path = 'super-admin/revenue/'+id
	return api.get(path);
}
const DeleteRevenueCode= async(id) =>{
	let path = 'super-admin/revenue/'+id
	return api.destroy(path);
}

const UpdateRevenueCode= async(id,data) =>{
	let path = 'super-admin/revenue/'+id
	return api.put(path,data);
}

const ImportCSVData = async(data) =>{
	let path = 'super-admin/import-revenue/'
	return api.post(path,data);
}

export default {GetListRevenueCode,AddRevenueCode,GetRevenueCode,DeleteRevenueCode,UpdateRevenueCode,ImportCSVData}